import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import apiClient, { getErrorMessage } from '../services/api-client';
import { Navigate } from 'react-router-dom';

import AppConfig from '../services/app-config';
import AuthService from '../services/auth';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';

import eventReportService from '../services/event-report';

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import GridViewRoundedIcon from '@mui/icons-material/GridViewRounded';
import { alpha } from '@mui/material/styles';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://migarita.online">
        MiGarita.Online
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}
export default function Login({window,setNavbarState, navbarState}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' })
  const [email, setEmail] = React.useState("");
  const [showPwdReset,setShowPwdReset] = React.useState(false);
  const [severity, setSeverity] = React.useState("warning");
  const [password, setPassword] = React.useState("");
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const apiUrl = process.env.REACT_APP_MGO_API_URL;
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [logoLoadError, setLogoLoadError] = React.useState(false);

  
  const togglePwdReset = () => {
    setShowPwdReset(!showPwdReset);
  }

  const handleResetPassword = async () => {
    try {
      setShowBackdrop(true);
      const res = await apiClient.post('request/reset/login', { email }, {}, { action: 'request_password_reset' });
      if (res.status === 200) {
        setSeverity("success");
        setSnackbarOpen(true);
        setSnackbarMessage("Si el correo es valido en nuestra base de datos, se ha enviado un correo electrónico para restablecer tu contraseña.");
        setShowPwdReset(false);
      }
    } catch (err) {
      console.log(err.message);
    } finally {
      setShowBackdrop(false);
    }
  }

  const pwdResetContent = (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', px: 3, maxWidth: 550, mx: 'auto', width: '100%' }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1, textAlign: 'center' }}>
          Restablecer Contraseña
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 4, textAlign: 'center' }}>
          Ingresa tu correo electrónico y te enviaremos instrucciones para restablecer tu contraseña.
        </Typography>
        <TextField
          fullWidth
          size="medium"
          value={email}
          id="reset-email"
          label="Correo Electrónico"
          placeholder="ejemplo@correo.com"
          variant="outlined"
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            mb: 3,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark'
                  ? alpha(theme.palette.common.white, 0.06)
                  : alpha(theme.palette.common.black, 0.03),
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />
        <Button
          fullWidth
          variant="contained"
          onClick={handleResetPassword}
          color="primary"
          size="large"
          sx={{
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 600,
          }}
        >
          Enviar Instrucciones
        </Button>
      </Box>
    </Box>
  );

  const [showPassword, setShowPassword] = React.useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleLogin = async () => {
    if (email === "" || password === "") {
      setSeverity("warning");
      setSnackbarOpen(true);
      setSnackbarMessage("Porfavor llene todos los campos.");
      return;
    }
    try {
      setShowBackdrop(true);
      const res = await apiClient.post('login', { "username": email,"password": password }, {}, { action: 'login' });
      AppConfig.parseResponse(res);
      if (res.status === 200) {
        AuthService.setToken(res?.data?.token);
        eventReportService("login", { email: email });
        const pendingTourStage = typeof window !== 'undefined' ? window.sessionStorage.getItem('mgo_admin_tour_stage_v1') : null;
        if (pendingTourStage && pendingTourStage !== 'completed') {
          setRedirect({ trigger: true, route: '/servicios' });
        } else {
          setRedirect({ trigger: true, route: '/' });
        }
      }
    } catch (err) {
      if(err.response && err.response.status === 401) {
        setSeverity("error");
        setSnackbarOpen(true);
        setSnackbarMessage("Correo o Contraseña Incorrecta");
      } else {
        console.log(err.message);
      }
    } finally {
      setShowBackdrop(false);
    }
  }

  const handleKeyPress = (event) => {
    if(event.key === 'Enter'){
      handleLogin();
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  React.useEffect(() => {
    setNavbarState({ ...navbarState, showBack: false, showOptions: false, showSearch: false})
  }, [])

  return (
    <Container maxWidth="sm" sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', py: 4 }}>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
      <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleClose} anchorOrigin={{ vertical: "top", horizontal: "center" }} sx={{mt: "3.2rem"}} >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Backdrop open={showBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 5 }}>
        <Box sx={{
          width: 72, height: 72, borderRadius: 3,
          backgroundColor: 'primary.main', display: 'flex',
          alignItems: 'center', justifyContent: 'center', mb: 2
        }}>
          {!logoLoadError ? (
            <Box
              component="img"
              src="/logo.svg"
              alt="MiGarita.Online"
              onError={() => setLogoLoadError(true)}
              sx={{ width: 42, height: 42 }}
            />
          ) : (
            <GridViewRoundedIcon sx={{ color: '#fff', fontSize: 36 }} />
          )}
        </Box>
        <Typography variant="h4" component="h1" align='center' sx={{ fontWeight: 700, color: 'primary.main', mb: 0.5 }}>
          MiGarita.Online
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          Gestión Residencial Inteligente
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}>
          Correo Electrónico
        </Typography>
        <TextField
          fullWidth size="medium" type='email' id='email'
          placeholder="ejemplo@correo.com"
          variant="outlined" value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            mb: 2.5,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark'
                  ? alpha(theme.palette.common.white, 0.06)
                  : alpha(theme.palette.common.black, 0.03),
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
        />

        <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5, color: 'text.primary' }}>
          Contraseña
        </Typography>
        <TextField
          fullWidth size="medium"
          type={showPassword ? 'text' : 'password'} id='password'
          placeholder="••••••••"
          variant="outlined" value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          sx={{
            mb: 1,
            '& .MuiOutlinedInput-root': {
              borderRadius: 2,
              backgroundColor: (theme) =>
                theme.palette.mode === 'dark'
                  ? alpha(theme.palette.common.white, 0.06)
                  : alpha(theme.palette.common.black, 0.03),
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleTogglePasswordVisibility}
                  onMouseDown={(e) => e.preventDefault()}
                  edge="end"
                  size="small"
                >
                  {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
          <Link
            component="button"
            variant="body2"
            onClick={togglePwdReset}
            sx={{ color: 'primary.main', fontWeight: 500, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
          >
            ¿Olvidé mi contraseña?
          </Link>
        </Box>

        <Button
          fullWidth variant="contained"
          onClick={handleLogin}
          endIcon={<ArrowForwardIcon />}
          sx={{
            py: 1.5, borderRadius: 2, textTransform: 'none',
            fontSize: '1rem', fontWeight: 600,
            backgroundColor: 'primary.main', '&:hover': { backgroundColor: 'primary.dark' }
          }}
        >
          Iniciar Sesión
        </Button>
      </Box>

      <Box sx={{ mt: 4, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          ¿Aún no tienes cuenta?{' '}
          <Link href="#" sx={{ color: 'primary.main', fontWeight: 600, textDecoration: 'none' }}>
            Contacta a tu administrador
          </Link>
        </Typography>
      </Box>

      <Box sx={{ mt: 3, textAlign: 'center' }}>
        <Copyright />
      </Box>

      <Dialog
        fullScreen
        open={showPwdReset}
        onClose={togglePwdReset}
        TransitionProps={{ timeout: 300 }}
      >
        <AppBar position="static" elevation={0} sx={{ backgroundColor: 'transparent' }}>
          <Toolbar>
            <Box sx={{ flex: 1 }} />
            <IconButton edge="end" onClick={togglePwdReset} sx={{ color: 'text.primary' }}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <DialogContent sx={{ p: 0 }}>
          {pwdResetContent}
        </DialogContent>
      </Dialog>
    </Container>
  );
}